// extracted by css-extract-rspack-plugin
var _1 = "src-components-Modal-Modal-module__actions-QRAzvV";
var _2 = "src-components-Modal-Modal-module__description-bkfyAf";
var _3 = "src-components-Modal-Modal-module__fadeIn-DTMSs4";
var _4 = "src-components-Modal-Modal-module__modal-JWRwyl";
var _5 = "src-components-Modal-Modal-module__overlay-KVFUfP";
var _6 = "src-components-Modal-Modal-module__title-ZsqU36";
var _7 = "src-components-Modal-Modal-module__visible-lsFSIu";
export { _1 as "actions", _2 as "description", _3 as "fadeIn", _4 as "modal", _5 as "overlay", _6 as "title", _7 as "visible" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"actions\":\"src-components-Modal-Modal-module__actions-QRAzvV\",\"description\":\"src-components-Modal-Modal-module__description-bkfyAf\",\"fadeIn\":\"src-components-Modal-Modal-module__fadeIn-DTMSs4\",\"modal\":\"src-components-Modal-Modal-module__modal-JWRwyl\",\"overlay\":\"src-components-Modal-Modal-module__overlay-KVFUfP\",\"title\":\"src-components-Modal-Modal-module__title-ZsqU36\",\"visible\":\"src-components-Modal-Modal-module__visible-lsFSIu\"}";
        // 1752373455108
        var cssReload = require("../../../node_modules/.pnpm/@rspack+core@1.4.6_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  